import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _tagged_template_literal from "@swc/helpers/src/_tagged_template_literal.mjs";
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  position: fixed;\n  /* padding-top: ",
        "; */\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  flex-shrink: 0;\n  background-color: ",
        ";\n  width: ",
        ";\n  height: 100vh;\n  transition: padding-top 0.2s, width 0.2s;\n  border-right: ",
        ";\n  z-index: 21;\n  overflow: ",
        ";\n  transform: translate3d(0, 0, 0);\n\n  ",
        " {\n    border-right: 2px solid rgba(133, 133, 133, 0.1);\n    width: ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  height: 100px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import PanelBody from "./PanelBody";
import { SIDEBAR_WIDTH_REDUCED, SIDEBAR_WIDTH_FULL } from "../config";
import Flex from "../../Box/Flex";
var StyledPanel = styled.div.withConfig({
    componentId: "sc-b5681a21-0"
})(_templateObject(), function(param) {
    var isMobile = param.isMobile;
    return isMobile ? "80px" : 0;
}, function(param) {
    var theme = param.theme;
    return theme.nav.background;
}, function(param) {
    var isPushed = param.isPushed, isMobile = param.isMobile;
    return !isMobile || isPushed ? "".concat(SIDEBAR_WIDTH_FULL, "px") : 0;
}, function(param) {
    var isPushed = param.isPushed;
    return isPushed ? "2px solid rgba(133, 133, 133, 0.1)" : 0;
}, function(param) {
    var isPushed = param.isPushed;
    return isPushed ? "initial" : "hidden";
}, function(param) {
    var theme = param.theme;
    return theme.mediaQueries.nav;
}, function(param) {
    var isPushed = param.isPushed;
    return "".concat(isPushed ? SIDEBAR_WIDTH_FULL : SIDEBAR_WIDTH_REDUCED, "px");
});
var LogoPanel = styled.div.withConfig({
    componentId: "sc-b5681a21-1"
})(_templateObject1());
var Panel = function(props) {
    var isPushed = props.isPushed, showMenu = props.showMenu, isMobile = props.isMobile;
    return /*#__PURE__*/ _jsxs(StyledPanel, {
        isPushed: isPushed,
        showMenu: showMenu,
        isMobile: isMobile,
        children: [
            /*#__PURE__*/ _jsx(Flex, {
                justifyContent: "center",
                alignItems: "center",
                style: {
                    padding: "20px 0",
                    marginLeft: "-15px"
                },
                children: /*#__PURE__*/ _jsx("img", {
                    // src="https://s3.ap-southeast-1.amazonaws.com/noahark.pro/logo002.png"
                    src: "https://s3.ap-northeast-1.amazonaws.com/1noahark.io/image/logo002.png",
                    width: 100,
                    height: 100,
                    alt: "logo"
                })
            }),
            /*#__PURE__*/ _jsx(PanelBody, _object_spread({}, props))
        ]
    });
};
export default Panel;
